var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBulb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 258,
    viewBox: "0 0 240 258",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_445_7022)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.4375 197.569L94.0995 201.42L117.131 207.898L156.053 218.856V175.542C162.498 171.591 168.225 166.636 173.092 160.776C183.388 148.394 189.06 132.691 189.06 116.568C189.06 78.4182 158.017 47.3754 119.867 47.3754C81.7177 47.3754 50.6748 78.4182 50.6748 116.568C50.6748 139.478 61.7103 160.434 80.3713 173.379M162.542 152.003C157.918 157.576 152.334 162.122 145.966 165.521L142.325 167.453V203.528L94.0995 189.954V165.841L90.833 163.833C74.2797 153.647 64.403 135.979 64.403 116.568C64.403 85.9886 89.288 61.1035 119.867 61.1035C150.447 61.1035 175.332 85.9886 175.332 116.568C175.332 129.491 170.785 142.071 162.542 152.003Z",
    fill: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.053 246.467V257.933L80.4375 236.634V225.168L156.053 246.467Z",
    fill: "#7C9299"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.053 226.934V238.389L96.5052 221.626L80.4375 217.101V205.635L137.204 221.626L156.053 226.934Z",
    fill: "#7C9299"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.592 0H112.143V41.4052H127.592V0Z",
    fill: "#7C9299"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.011 112.143H198.605V127.592H240.011V112.143Z",
    fill: "#7C9299"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4052 112.419H0V127.868H41.4052V112.419Z",
    fill: "#7C9299"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5183 29.7794L29.5938 40.704L58.8716 69.9819L69.7962 59.0573L40.5183 29.7794Z",
    fill: "#7C9299"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.592 0H112.143V41.4052H127.592V0Z",
    fill: "#7C9299"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.297 29.5924L170.02 58.8702L180.944 69.7948L210.222 40.5169L199.297 29.5924Z",
    fill: "#7C9299"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_445_7022"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 240,
    height: 257.933,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulb);
export default __webpack_public_path__ + "static/media/bulb.7886e3245a9b8ecb01783f59b8956c90.svg";
export { ForwardRef as ReactComponent };